"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolTeacherSerializer = void 0;
class SchoolTeacherSerializer {
    constructor() { }
    serializeOne({ id, externalId, firstName, middleName, lastName, username, email, sisId, enrollmentStatus, schoolEnrollmentStatus, classEnrollments, schoolArchivedAt, }) {
        return {
            id,
            externalId,
            firstName,
            lastName,
            middleName,
            username,
            email,
            sisId,
            enrollmentStatus,
            schoolEnrollmentStatus,
            classEnrollments,
            schoolArchivedAt,
        };
    }
}
exports.SchoolTeacherSerializer = SchoolTeacherSerializer;
//# sourceMappingURL=school-teacher.serializer.js.map